import { buttonSharedStates } from '@shared/utils/style/buttons';
import { ButtonV2, InputV2Props, styled, Toggle } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { StyledInputContainer } from '@withjoy/joykit/components/InputV1/StyledInputContainer';
import { Placeholder } from '@withjoy/joykit/components/SelectV1/styles';

export const inputOverrides: InputV2Props['overrides'] = {
  Root: {
    props: {
      _hover: {
        borderColor: 'mono14',
      },
    },
  },
};

export const StyledToggle = styled(Toggle)`
  input:checked ~ .joykit-choice-indicator {
    background-color: ${({ theme }) => theme.colors.mono14};
  }
  input ~ .joykit-choice-indicator {
    width: 56px;
  }
  input:checked ~ .joykit-choice-indicator::before {
    transform: translateY(-50%) translateZ(0.1px) translateX(27px) !important;
  }
`;

// overrides to style SelectV1 InputV1s to look like InputV2
export const inputV1ToV2Styles = (isInvalid?: boolean, error?: string, isDisabled?: boolean): CSSObject => {
  return {
    ['& > div']: {
      width: '100% !important',
    },
    [`${StyledInputContainer}`]: {
      outline: isInvalid || error ? '2px solid #c50020' : '2px solid transparent',
      borderRadius: '4px',
      _after: {
        border: '0px solid transparent',
        borderRadius: '4px',
        boxShadow: isInvalid || error ? '0px 0 0px 1px #c50020' : isDisabled ? '0px 0 0px 1px #D9D9D9' : '0px 0 0px 1px #333',
        content: '" "',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
      },
      ['input']: {
        outline: 0,
        _focus: { outline: 0 },
        fontSize: '1rem !important',
        borderRadius: '4px',
        color: '#333',
        paddingRight: '48px !important',
        _hover: {
          borderColor: '#333',
        },
        _disabled: {
          border: 0,
          backgroundColor: '#F7F7F7',
        },
      },
    },
    [Placeholder]: {
      color: isDisabled ? '#767676' : '',
    },
  };
};

export const StyledActionButton = styled(ButtonV2)`
  ${buttonSharedStates};
`;
